import { render, staticRenderFns } from "./packageAllocation.vue?vue&type=template&id=b0f5c3a0&"
import script from "./packageAllocation.vue?vue&type=script&lang=js&"
export * from "./packageAllocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports